// src/components/Board/PostSearchPanel.js
import React, { useEffect, useState } from "react";
import boardApi from "../../api/boardApi";

const PostSearchPanel = ({ boardSlug, onSearch, onTagSelect }) => {
  const [searchInput, setSearchInput] = useState("");
  const [tags, setTags] = useState([]);

  useEffect(() => {
    if (!boardSlug) {
      setTags([]); // ✅ 게시판 선택 해제 시 태그도 비움
      return;
    }

    const fetchTags = async () => {
      try {
        const res = await boardApi.get(`/api/boards/${boardSlug}/tags/`);
        setTags(res.data); // ['python', 'devops', ...]
      } catch (err) {
        console.error("❌ 태그 불러오기 실패", err);
      }
    };

    fetchTags();
  }, [boardSlug]);

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(searchInput);
  };

  // ✅ boardSlug 없으면 UI 자체를 숨김
  if (!boardSlug) return null;

  return (
    <div>
      <h2 className="text-lg font-bold mb-2">🔍 검색 및 태그</h2>
      <form onSubmit={handleSearch} className="mb-4">
        <input
          type="text"
          placeholder="검색어 입력"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="w-full border px-2 py-1 rounded mb-2"
        />
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-1 rounded"
        >
          검색
        </button>
      </form>

      <div>
        <h3 className="font-semibold mb-1">📌 태그 목록</h3>
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <span
              key={tag}
              onClick={() => onTagSelect(tag)}
              className="cursor-pointer bg-gray-200 px-2 py-1 rounded hover:bg-blue-200"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostSearchPanel;
